<!-- Modal -->
<div class="block mx-auto modal-box">
    <div class="modal1" id="modal-signup">
        <div class="block mx-auto boxshadow">
            <div class="row">
                <div class="col-12">
                    <div class="content bank-modal-content referral-modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ (data.type == 'connection-err' ? 'CONNECTION ERROR' : 'RELOAD PAGE') | translate }}</h4>
                            <button title="Close (Esc)" type="button" class="close-title" (click)="onCloseDialog()" [innerHTML]="svg.closeIcon | safeHtml"></button>
                        </div>
                        <label class="mt-2 mb-4">
                            {{ (data.type == 'connection-err' ? 'You\'re not connected to the internet. Please check your connection and try again.' : 'A new version of the app is ready. Please tap below to update.') | translate }}
                        </label>
                        <div class="col-12 form-group p-l-0 p-r-0">
                            <button class="main-button-1" (click)="onReload()">{{ data.type == 'connection-err' ? ('Try again' | translate) : ('Update' | translate | uppercase) }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>